import { findTipospublicacao } from '@/services/tipospublicacao';
import { findSegmentos } from '@/services/segmentos';
import { findTiposObjeto } from '@/services/tipoObjeto';
import { documental } from '@/services/relatorio';
import notifyError from '@/lib/notify-error';

const Getters = {
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  query(st, gt, rSt) {
    const query = [];
    if (rSt.route.query) {
      if (rSt.route.query.idTipopublicacao) {
        const data = st.tipoPublicacoes.find(seg => Number(seg.idTipopublicacao)
            === Number(rSt.route.query.idTipopublicacao));
        if (data) {
          query.push({
            title: 'Tipo de acervo',
            data: data.tipoPublicacao,
          });
        }
      } else {
        query.push({
          title: 'Tipo de acervo',
          data: 'Textual e Peças',
        });
      }
      if (rSt.route.query.idSegmento) {
        const data = st.segmentos.find(seg => Number(seg.id)
        === Number(rSt.route.query.idSegmento));
        if (data) {
          query.push({
            title: 'Área',
            data: data.segmento,
          });
        }
      } else {
        query.push({
          title: 'Área',
          data: 'Todas',
        });
      }
      if (rSt.route.query.idTipoObjeto) {
        const data = st.tipoObjetos.find(seg => Number(seg.id)
        === Number(rSt.route.query.idTipoObjeto));
        if (data) {
          query.push({
            title: 'Tipo de Objeto/Espécie Documental',
            data: data.tipoObjeto,
          });
        } else {
          query.push({
            title: 'Tipo de Objeto/Espécie Documental',
            data: 'Outros',
          });
        }
      } else {
        query.push({
          title: 'Tipo de Objeto/Espécie Documental',
          data: 'Todos',
        });
      }
      return query;
    }
    return [];
  },
  segmento(st, gt, rSt) {
    if (rSt.route.query && rSt.route.query.idSegmento) {
      return st.segmentos.find(seg => Number(seg.id) === Number(rSt.route.query.idSegmento));
    }
    return {};
  },
  tipoPublicacao(st, gt, rSt) {
    if (rSt.route.query && rSt.route.query.idTipopublicacao) {
      return st.tipoPublicacoes.find(seg => Number(seg.idTipopublicacao)
      === Number(rSt.route.query.idTipopublicacao));
    }
    return {};
  },
  tipoObjetos(st, gt, rSt) {
    if (rSt.route.query && rSt.route.query.idTipoObjeto) {
      return st.tipoObjetos.find(seg => Number(seg.idTipoObjeto)
      === Number(rSt.route.query.idTipoObjeto));
    }
    return {};
  },
  result(st) {
    return st.result;
  },
  loading(st) {
    return st.loading;
  },
  csvData(st) {
    if (st.result && st.result.publicacoes) {
      return st.result.publicacoes.map(res => ({
        registro: res.registro.trim(),
        titulo: res.titulo,
        localizacao: res.localizacao,
        tipoOuEspecie: res.tipoOuEspecie,
      }));
    }
    return [];
  },
};
const mutations = {
  setTipoPublicacoes(state, tipoPublicacoes) {
    state.tipoPublicacoes = tipoPublicacoes;
  },
  setSegmentos(state, segmentos) {
    state.segmentos = segmentos;
  },
  setTipoObjetos(state, tipoObjetos) {
    state.tipoObjetos = tipoObjetos;
  },
  setResult(state, result) {
    state.result = result;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};
const actions = {
  afterRouteUpdate({ dispatch }) {
    dispatch('findTipospublicacao');
    dispatch('findSegmentos');
    dispatch('findTiposObjeto');
    dispatch('getResult');
  },
  findTipospublicacao({ commit }) {
    findTipospublicacao({ where: { base: 'S' } })
      .then(items => commit('setTipoPublicacoes', items));
  },
  findSegmentos({ commit }) {
    findSegmentos({ where: { idCanalPadrao: 273 } })
      .then(items => commit('setSegmentos', items));
  },
  findTiposObjeto({ commit }) {
    findTiposObjeto({ order: 'tipoObjeto ASC', where: { or: [{ idTipopublicacao: 40 }, { idTipopublicacao: 57 }] } })
      .then(items => commit('setTipoObjetos', items));
  },
  getResult({ rootState, commit }) {
    commit('setLoading', true);
    const filter = Object.assign({}, rootState.route.query);
    documental(filter)
      .then((result) => {
        commit('setResult', result);
      })
      .catch(err => notifyError(err))
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

export default {
  namespaced: true,
  state: {
    segmentos: [],
    tipoPublicacoes: [],
    tipoObjetos: [],
    result: {},
    loading: false,
  },
  mutations,
  getters: Getters,
  actions,
};
